import { useLang } from '@/i18n';
import AchorIcon from '@elem/SVGIcon/NextLevelPower/Achor';
import EfCardList from '@elem/ui/ef-card-list';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';

export default function PowerSolutions() {
    const { t } = useLang('fourinone.teaser');

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124061787/power_solution_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724138869339/power_solution_1_h5.jpg',
            title: t('power_solutions_card_title_1'),
            href: '#ID-SectionA',
            gtm_position: t('power_solutions_card_desc_1_1'),
            description: (
                <div className="power-desc-box">
                    <p className="power-desc-item">{t('power_solutions_card_desc_1_1')}</p>
                    <span className="power-desc-item-icon">
                        <AchorIcon />
                    </span>
                </div>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124061585/power_solution_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724138846492/power_solution_2_h5.jpg',

            title: t('power_solutions_card_title_2'),
            href: '#ID-SectionB',
            gtm_position: t('power_solutions_card_desc_2_1'),

            description: (
                <div className="power-desc-box">
                    <p className="power-desc-item">{t('power_solutions_card_desc_2_1')}</p>
                    <span className="power-desc-item-icon">
                        <AchorIcon />
                    </span>
                </div>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124062198/power_solution_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724138846662/power_solution_3_h5.jpg',

            title: t('power_solutions_card_title_3'),
            href: '#ID-SectionB',
            gtm_position: t('power_solutions_card_desc_3_1'),

            description: (
                <div className="power-desc-box">
                    <p className="power-desc-item">{t('power_solutions_card_desc_3_1')}</p>
                    <span className="power-desc-item-icon">
                        <AchorIcon />
                    </span>
                </div>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124062392/power_solution_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724138845962/power_solution_4_h5.jpg',

            title: t('power_solutions_card_title_4'),
            gtm_position: t('power_solutions_card_desc_4_1'),

            href: '#ID-SectionC',
            description: (
                <div className="power-desc-box">
                    <p className="power-desc-item">{t('power_solutions_card_desc_4_1')}</p>
                    <span className="power-desc-item-icon">
                        <AchorIcon />
                    </span>
                </div>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724124062008/power_solution_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724138846883/power_solution_5_h5.jpg',

            title: t('power_solutions_card_title_5'),
            href: '#ID-SectionD',
            gtm_position: t('power_solutions_card_desc_5_1'),

            description: (
                <div className="power-desc-box">
                    <p className="power-desc-item">{t('power_solutions_card_desc_5_1')}</p>
                    <span className="power-desc-item-icon">
                        <AchorIcon />
                    </span>
                </div>
            ),
        },
    ];
    return (
        <div className={`${styles.PowerSolutions} power-solutions-box`}>
            <EfTitle>{t('power_solutions_title')}</EfTitle>
            <EfCardList list={list} isSwiper={false} />
        </div>
    );
}
